import type { SoftpayLibrary } from '../../types/softpay';
import type { ENV } from '../../config';
import config from '../../config';

//@ts-ignore
const softpayLibrary = Softpay as SoftpayLibrary;

const getEnv = (env: ENV) => {
  if (env === 'prod') {
    return {
      pkg: 'io.softpay',
      pwa: true,
    };
  }
  return {
    env: 'sandbox',
    pkg: 'io.softpay',
    pwa: true,
  };
};

export const softpayClient =
  softpayLibrary === undefined
    ? undefined
    : softpayLibrary.newClient({
        callback: false,
        env: getEnv(config.env),
      });

export default softpayClient;
